<template>
	<div id="app">
		<header-ui />
		<full-page-takeover />
	</div>
</template>

<script>
	import HeaderUi from '@/components/global/HeaderUi';
	import FullPageTakeover from '@/components/sections/FullPageTakeover';

	export default {
		name: 'app',
		components: {
			HeaderUi,
			FullPageTakeover,
		}
	}
</script>